var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * StarCircle component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconStarCircle extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.4064 7.03652L13.0724 6.69169C12.9692 6.49242 12.8124 6.32599 12.6196 6.21122C12.4267 6.09644 12.2057 6.0379 11.9813 6.04221C11.757 6.04653 11.5383 6.11353 11.35 6.23563C11.1646 6.35587 11.016 6.52483 10.9204 6.7239L9.64866 9.28215L6.8193 9.69692L6.81929 9.69684L6.80814 9.69865C6.59021 9.73395 6.3862 9.82857 6.21848 9.97212C6.05076 10.1157 5.92578 10.3026 5.85725 10.5125C5.78873 10.7224 5.77929 10.947 5.82998 11.1619C5.88067 11.3768 5.98952 11.5736 6.14462 11.7307L6.15968 11.7455L8.19956 13.6986L7.71995 16.5463C7.67691 16.7684 7.6974 16.9983 7.77925 17.2095C7.86334 17.4265 8.00857 17.6144 8.19733 17.7505C8.38609 17.8866 8.61028 17.965 8.84271 17.9762C9.06873 17.9871 9.2931 17.934 9.49011 17.8232L12.0006 16.4942L14.5111 17.8232C14.7081 17.934 14.9324 17.9871 15.1585 17.9762C15.3909 17.965 15.6151 17.8866 15.8038 17.7505C15.9926 17.6144 16.1378 17.4265 16.2219 17.2095C16.3023 17.0021 16.3235 16.7765 16.2834 16.558L15.8683 13.6364L17.8372 11.7652C18.0025 11.6103 18.1206 11.4117 18.1781 11.1925C18.2359 10.9716 18.2297 10.7388 18.1601 10.5213C18.0905 10.3038 17.9604 10.1106 17.785 9.96434C17.6122 9.82018 17.4025 9.72744 17.1797 9.69658L14.3529 9.26739L13.078 6.70266L12.4064 7.03652ZM12.0045 7.91286L10.93 10.0742C10.8462 10.2555 10.7174 10.4125 10.5557 10.5301C10.3937 10.6479 10.2042 10.7222 10.0055 10.7459L7.64588 11.0918L9.39773 12.7691C9.42025 12.7906 9.4414 12.8136 9.46107 12.8378C9.58459 12.9898 9.66858 13.1699 9.70556 13.3623C9.73855 13.5338 9.73323 13.7103 9.69029 13.8791L9.29441 16.2296L11.4312 15.0984C11.445 15.0911 11.459 15.0842 11.4733 15.0777C11.639 15.0029 11.8187 14.9641 12.0006 14.9641C12.1824 14.9641 12.3622 15.0029 12.5279 15.0777C12.5422 15.0842 12.5562 15.0911 12.57 15.0984L14.7229 16.2381L14.3933 13.9183C14.3464 13.789 14.3222 13.6521 14.3222 13.5137C14.3222 13.3217 14.3687 13.1326 14.4579 12.9626C14.496 12.8898 14.5459 12.8238 14.6055 12.7672L16.3694 11.0908L13.9933 10.73C13.7954 10.706 13.6068 10.6318 13.4455 10.5145C13.2837 10.3969 13.1549 10.2399 13.0711 10.0586L12.0045 7.91286ZM16.9763 11.1827C16.9742 11.1824 16.9721 11.1822 16.97 11.1818L16.9763 11.1827ZM12.2707 7.37699L12.2736 7.37108C12.2727 7.37306 12.2717 7.37503 12.2707 7.37699Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.0005 2.60449C6.81175 2.60449 2.60547 6.81078 2.60547 11.9995C2.60547 17.1882 6.81175 21.3945 12.0005 21.3945C17.1892 21.3945 21.3955 17.1882 21.3955 11.9995C21.3955 6.81078 17.1892 2.60449 12.0005 2.60449ZM1.10547 11.9995C1.10547 5.98235 5.98333 1.10449 12.0005 1.10449C18.0176 1.10449 22.8955 5.98235 22.8955 11.9995C22.8955 18.0166 18.0176 22.8945 12.0005 22.8945C5.98333 22.8945 1.10547 18.0166 1.10547 11.9995Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconStarCircle.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconStarCircle.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconStarCircle.prototype, "size", void 0);
if (customElements.get('cat-icon-star-circle') === undefined) {
    customElements.define('cat-icon-star-circle', BlocksIconStarCircle);
}
